// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--bZOaI","tab":"_4f720283bf--tab--OHKWn","active":"_4f720283bf--active--rtuMv","disabled":"_4f720283bf--disabled--jYjE6"};